import { formatInTimeZone } from './dateTime';
import { preferredTimeZone } from './dayjs';

import type { AllowedFormatKey } from './dateFormats';

export const userTimeZone = preferredTimeZone;

// expecting iso8601 format, for example rails code Model.updated_at.utc.iso8601
const formatToUserTimeZone = (
  timeString: string | Date,
  format: AllowedFormatKey = 'long'
): string => formatInTimeZone(timeString, userTimeZone, format);

export default formatToUserTimeZone;
